import { Action, Mutation, Module } from "vuex-class-modules";
import Axios, { AxiosResponse } from "axios";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import AxiosSecureModule from "./axiosSecureModule";
import { Log } from "@/plugins/Logging";
import { app } from "@/store";
@Module({ generateMutationSetters: true })
export default class SensorModule extends AxiosSecureModule {
    devices: Array<AttachedDeviceModel> = [];
    public syncSensor = false;
    public seconds = 0;

    @Action
    public async GetData() {
        await this.defineHeaderAxios();
        Axios.get("api/sensor")
            .then((result: AxiosResponse) => {
                this.SetData(result.data);
            })
            .catch((error) => {
                Log.error("", error);
            });
    }
    @Action
    public async GetPowerStatus() {
        await this.defineHeaderAxios();
        Axios.get("api/sensor/powerStatus")
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    Log.information("fetch sensor status");
                }
            })
            .catch((error) => {
                Log.error("", error);
            });
    }

    startSensorSync() {
        this.syncSensor = true;
        const checkStatus = () => {
            if (this.syncSensor) {
                if (this.seconds >= 20) {
                    app.error = "Sensor unresponsive !!!!!";
                    this.syncSensor = false;
                    this.GetData();
                } else {
                    app;
                    this.seconds += 1;
                }
            } else {
                clearInterval(intervalID);
                this.seconds = 0;
            }
        };
        const intervalID = setInterval(checkStatus, 1000);
    }

    @Action
    public async SetDeviceStatus(payload: { id: any; status: boolean }) {
        this.startSensorSync();
        await this.defineHeaderAxios();
        Axios.put(`api/sensor/status/${payload.id}/${payload.status}`)
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    Log.information("set sensor status");
                }
            })
            .catch((error) => {
                this.syncSensor = false;
                Log.error("", error);
            });
    }
    @Action
    public async GetCoreHistory() {
        await this.defineHeaderAxios();
        Axios.get(`/api/sensor/CoreHistory`)
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    Log.information("get core history");
                }
            })
            .catch((error) => {
                Log.error("", error);
            });
    }
    @Action
    public async GetDeviceHistory(id: any) {
        await this.defineHeaderAxios();
        Axios.get(`/api/sensor/history/${id}`)
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    Log.information("get sensor history");
                }
            })
            .catch((error) => {
                Log.error("", error);
            });
    }

    @Action
    public async SetSensorAge(payload: {
        device: string;
        status: string;
        age: string;
        atPosition: any;
    }) {
        if (this.devices.length > 0) {
            const device = this.devices.find(
                (item: AttachedDeviceModel) =>
                    item.attachedDeviceId === payload.device
            );

            if (device) {
                device.age = Number(payload.age);
            } else {
                Log.information(
                    `Device not found in paired devices, ID=${payload.device}`
                );
            }
        } else {
            Log.information("No devices paired.");
        }
    }

    @Action
    public async GetSensorAge(id: any) {
        const index = this.devices.findIndex(
            (item: AttachedDeviceModel) => item.attachedDeviceId === id
        );
        if (index > 0) {
            return this.devices[index].age;
        }
    }

    @Mutation
    SetData(data: Array<AttachedDeviceModel>) {
        this.devices = data;
    }

    @Mutation
    SetSensorStatus(data: { id: string; value: string }) {
        const index = this.devices.findIndex(
            (item: AttachedDeviceModel) => item.attachedDeviceId === data.id
        );
        this.devices[index].alarm1 = data.value === "1";
    }
}
